import { createBrowserRouter } from "react-router-dom";

import AppInit from "@/layouts/wrappers/components/AppInit";
import AppError from "@/pages/error/AppError";
import { getLocaleBasePath } from "@/services/locale.service";

import AdminRoutes from "./admin.routes";
import AppRoutes from "./app.routes";
import OnboardingRoutes from "./onboarding.routes";
import PublicRoutes from "./public.routes";

const routes = [
  {
    element: <AppInit/>,
    errorElement: <AppError/>,
    children: [
      ...PublicRoutes,
      ...OnboardingRoutes,
      ...AppRoutes,
      ...AdminRoutes,
    ]
  }
];

const router = createBrowserRouter(routes, {
  basename: typeof window !== "undefined" ? getLocaleBasePath(window.location.pathname) : "",
});

export default router;
